import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEventCallback } from 'usehooks-ts';

import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import {
  MyProfile,
  ProfileSkeleton,
} from '@/features/profile/components/profile';
import { getMyProfileOptions } from '@/features/profile/hooks/useGetMyProfile/getMyProfile.options';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute(
  '/_protected/_app/_mainLayout/profiles/me',
)({
  loader: async ({ context }) => {
    const profileData = await context.queryClient.ensureQueryData(
      getMyProfileOptions(),
    );

    // Prefetch valorant data if riotPuuid is available
    if (profileData.profile?.riotPuuid) {
      await context.queryClient.ensureQueryData(
        getValorantPlayerOptions({ puuid: profileData.profile.riotPuuid }),
      );
    }
  },
  pendingComponent: () => (
    <MainLayout.Root className="h-full">
      <PageHeader.Root>
        <PageHeader.BackButton
          onClick={() => {
            window.history.back();
          }}
        />
      </PageHeader.Root>
      <MainLayout.Content className="mx-auto flex min-h-0 w-full flex-col overflow-hidden px-4 lg:max-w-100">
        <ProfileSkeleton className="mb-2 max-h-165 min-h-0 w-full max-w-100 flex-1" />
      </MainLayout.Content>
    </MainLayout.Root>
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      void navigate({ to: '/' });
    }
  });

  return (
    <MainLayout.Root className="h-full">
      <PageHeader.Root>
        <PageHeader.BackButton onClick={handleGoBack} />
      </PageHeader.Root>
      <MainLayout.Content className="flex min-h-0 w-full flex-col items-center px-4">
        <MyProfile className="mb-4 max-h-full min-h-0 w-full max-w-100" />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
